import Vue from "vue";
import VueI18n from "vue-i18n";
import EventBus from "../utils/event-bus"
import { EVENT_BUS } from "../common/constants"

Vue.use(VueI18n);

let langCode = localStorage.getItem("lang");
if (langCode === undefined || langCode === null) {
  langCode = "en-US";
  localStorage.setItem("lang", langCode);
}

const i18n: VueI18n = new VueI18n({
  locale: langCode,
  fallbackLocale: langCode,
  silentTranslationWarn: true
});

function localizeMessage(langCode, callback) {
  import("./langs/" + langCode + ".json")
    .then(translatedContent => {
      import("./langs/" + langCode + ".web.json").then(
        extTranslatedContent => {
          return callback(
            true,
            Object.assign(translatedContent.default, extTranslatedContent.default) // https://webpack.js.org/migrate/4/#import-and-commonjs
          );
        }
      );
    })
    .catch(exception => {
      callback(false, null);
      throw new Error(exception);
    });
}

export const localizeMessageHanlder = (langCode) => {
    localizeMessage(langCode, (isAvailable, data) => {
        if (isAvailable && data !== null) {
            i18n.setLocaleMessage(langCode, data);
            EventBus.$emit(EVENT_BUS.COMMON.LOADED_TRANSALTED)
            console.log(`Localized ${langCode} sucessfully`);
        }
    })
}

localizeMessageHanlder(langCode);

export default i18n;
